/**
 * PowerPoint Compressor - /documents/powerpoint page
 */
import { createApp } from 'vue';
import PowerpointCompressor from '@/Components/PowerpointCompressor.vue';
import '@styles/app.css';

createApp(PowerpointCompressor).mount('#powerpoint-compressor');
